import React from 'react';
import PropTypes from 'prop-types';
import styles from './matchInteraction.scss';
import AlternativeCell from './AlternativeCell';
import InteractionNumber from './InteractionNumber';

const MatchInteractionRow = (props) => {
    const {
        correctResponses,
        handleUserResponse,
        isInverted,
        isReadOnly,
        modelIdentifier,
        rowChoice,
        flaggedItems,
        questionModel,
        userResponse,
        matchColumns,
    } = props;

    const rowChoiceIdentifier = rowChoice.identifier;

    return (
        <tr key={`row_${rowChoiceIdentifier}`} aria-labelledby={`rowChoice_${rowChoiceIdentifier}`}>
            <th id={`rowChoice_${rowChoiceIdentifier}`}>
                <div className={styles.headerCellWrapper}>
                    { !isInverted &&
                        <InteractionNumber
                            modelIdentifier={modelIdentifier}
                            questionContentRevisionId={questionModel.contentRevisionId}
                            flaggedItems={flaggedItems}
                            choiceIdentifier={rowChoiceIdentifier}
                        />
                    }

                    <div className="inline" dangerouslySetInnerHTML={{ __html: rowChoice.content }} />
                </div>
            </th>

            { matchColumns.map((columnChoice) => {
                const columnChoiceIdentifier = columnChoice.identifier;
                return (<AlternativeCell
                    columnChoiceIdentifier={columnChoiceIdentifier}
                    correctResponses={correctResponses}
                    handleUserResponse={handleUserResponse}
                    modelIdentifier={modelIdentifier}
                    questionId={questionModel.identifier}
                    isInverted={isInverted}
                    isReadOnly={isReadOnly}
                    isSelected={userResponse.includes(`${rowChoiceIdentifier} ${columnChoiceIdentifier}`)}
                    key={columnChoiceIdentifier}
                    rowChoiceIdentifier={rowChoiceIdentifier}
                />);
            })}
        </tr>
    );
};

MatchInteractionRow.propTypes = {
    correctResponses: PropTypes.array,
    flaggedItems: PropTypes.array,
    handleUserResponse: PropTypes.func.isRequired,
    isInverted: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool,
    matchColumns: PropTypes.array.isRequired,
    modelIdentifier: PropTypes.string.isRequired,
    questionModel: PropTypes.object.isRequired,
    rowChoice: PropTypes.object.isRequired,
    userResponse: PropTypes.array.isRequired,
};

export default MatchInteractionRow;
